var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"minor",staticClass:"minor",class:{complete: _vm.headerImage}},[_c('input',{ref:"input_img",staticClass:"minor-label",attrs:{"type":"file","name":"","id":"minor","accept":"image/*"},on:{"change":_vm.uploadFile}})])])}
var staticRenderFns = []

export { render, staticRenderFns }